import { useRoles } from '../api/queries';
import { useTranslate } from '../i18n/useTranslate';
import { ErrorView } from '../ui/ErrorView';

/**
 * Rol listesi. İkinci menü öğesi olarak var: izin filtresinin GERÇEKTEN
 * çalıştığı ancak farklı izin gerektiren iki öğe varken görülebilir.
 */
export function RoleListPage() {
  const t = useTranslate();
  const roles = useRoles();

  if (roles.isPending) return <p>{t('roles.loading')}</p>;
  if (roles.isError) return <ErrorView error={roles.error} onRetry={() => void roles.refetch()} />;

  return (
    <section>
      <h1>{t('roles.title')}</h1>

      {roles.data.length === 0 ? (
        <p>{t('roles.empty')}</p>
      ) : (
        <ul className="list">
          {roles.data.map((role) => (
            <li key={role.id}>
              <span>{role.name}</span>
              {role.isSystem && <span className="badge">{t('roles.system')}</span>}
              <span className="badge">{role.permissions.length}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
